import { Typography } from '@/components/ui/typography';

interface RegistrationHeaderProps {
  title: string;
  subtitle: string;
  titleId?: string;
}

export const RegistrationHeader = ({
  title,
  subtitle,
  titleId,
}: RegistrationHeaderProps) => (
  <div className="text-center">
    <Typography as="h1" variant="heading-xl" id={titleId} className="sr-only">
      {title}
    </Typography>
    <Typography as="p" variant="body" className="text-[#212529]">
      {subtitle}
    </Typography>
  </div>
);
